import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import IOSSwitch from './switch.component';

export default function StatusSwitch({ checked, switchSx, ...props }) {
  const { t: translate } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        width: 'fit-content',
        px: 1.25,
        py: 0.75,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'action.hover',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          minWidth: 48,
          fontWeight: 600,
          color: checked ? 'primary.main' : 'text.secondary',
        }}
      >
        {checked
          ? translate('common.active', { defaultValue: 'Active' })
          : translate('common.inactive', { defaultValue: 'Inactive' })}
      </Typography>
      <IOSSwitch
        checked={checked}
        {...props}
        sx={[
          {
            '& .MuiSwitch-track': { backgroundColor: 'secondary.main' },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: 'primary.main',
            },
          },
          ...(switchSx ? (Array.isArray(switchSx) ? switchSx : [switchSx]) : []),
        ]}
      />
    </Stack>
  );
}
